<template>
  <section class="mb-4">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="mb-0">{{ label }}</h5>
      <div>
        <input
          ref="imageInput"
          type="file"
          accept="image/*"
          multiple
          class="d-none"
          @change="addImages"
        />
        <b-button size="sm" variant="primary" @click="$refs.imageInput.click()">
          <i class="fa fa-plus"></i> Tambah Gambar
        </b-button>
      </div>
    </div>

    <small v-if="errorMessage" class="text-danger d-block mb-2">{{ errorMessage }}</small>
    <p v-if="images.length === 0" class="text-muted">{{ emptyText }}</p>
    <draggable
      v-else
      :value="images"
      class="row"
      handle=".image-multiple-drag-handle"
      @input="reorderImages"
    >
      <b-col
        v-for="(item, index) in images"
        :key="item.id"
        cols="6"
        md="4"
        lg="3"
        class="mb-3"
      >
        <b-card class="h-100 p-2">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <button
              type="button"
              class="btn btn-link p-0 image-multiple-drag-handle"
              :aria-label="`Pindahkan ${label.toLowerCase()} ${index + 1}`"
              title="Seret untuk mengubah urutan"
            >
              <i class="fa fa-bars"></i> {{ index + 1 }}
            </button>
            <b-button
              size="sm"
              variant="danger"
              :aria-label="`Hapus ${label.toLowerCase()} ${index + 1}`"
              @click="removeImage(item.id)"
            >
              <i class="fa fa-trash"></i> Hapus
            </b-button>
          </div>
          <img
            v-if="previews[item.id]"
            :src="previews[item.id]"
            :alt="`Preview ${label.toLowerCase()} ${index + 1}: ${item.file.name}`"
            class="img-fluid w-100"
            style="height: 180px; object-fit: contain"
          />
          <small class="text-truncate d-block mt-2" :title="item.file.name">{{ item.file.name }}</small>
        </b-card>
      </b-col>
    </draggable>
  </section>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'InputImageMultiple',
  components: { draggable },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Gambar',
    },
    emptyText: {
      type: String,
      default: 'Belum ada gambar.',
    },
  },
  data() {
    return {
      previews: {},
      previewFiles: {},
      nextImageId: 1,
      errorMessage: '',
    }
  },
  mounted() {
    this.syncPreviews(this.images)
    this.updateNextImageId()
  },
  beforeDestroy() {
    Object.values(this.previews).forEach(url => URL.revokeObjectURL(url))
  },
  computed: {
    images() {
      return this.value || []
    },
  },
  watch: {
    images: {
      deep: true,
      handler(images) {
        this.syncPreviews(images)
        this.updateNextImageId()
      },
    },
  },
  methods: {
    updateNextImageId() {
      const maxId = this.images.reduce((max, image) => Math.max(max, Number(image.id) || 0), 0)
      this.nextImageId = Math.max(this.nextImageId, maxId + 1)
    },
    syncPreviews(images) {
      const retainedIds = new Set(images.map(image => String(image.id)))
      Object.keys(this.previews).forEach((id) => {
        if (!retainedIds.has(String(id))) {
          URL.revokeObjectURL(this.previews[id])
          this.$delete(this.previews, id)
          this.$delete(this.previewFiles, id)
        }
      })
      images.forEach((image) => {
        if (image.file && this.previewFiles[image.id] !== image.file) {
          if (this.previews[image.id]) URL.revokeObjectURL(this.previews[image.id])
          this.$set(this.previews, image.id, URL.createObjectURL(image.file))
          this.$set(this.previewFiles, image.id, image.file)
        }
      })
    },
    addImages(event) {
      const files = Array.from(event.target.files || [])
      const validFiles = files.filter(file => file.type.startsWith('image/'))
      this.errorMessage = validFiles.length === files.length
        ? ''
        : 'Hanya file gambar yang dapat ditambahkan.'

      const additions = validFiles.map(file => ({ id: this.nextImageId++, file }))
      if (additions.length > 0) this.$emit('input', [...this.images, ...additions])
      event.target.value = ''
    },
    removeImage(id) {
      this.$emit('input', this.images.filter(image => image.id !== id))
    },
    reorderImages(images) {
      this.$emit('input', images)
    },
  },
}
</script>
